import { useState } from 'react';
import './ContactSection.css';
import contactObj from '../../assets/cta_house_solar2.png';
import contactWattle from '../../assets/figma_contact_wattle.svg';

const INITIAL_FORM = { hasSolarPanel: '', name: '', address: '', email: '', phone: '' };
const INITIAL_STATUS = { loading: false, success: false, error: false, message: '' };

export default function ContactSection() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState(INITIAL_STATUS);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: false, message: '' });
    setErrors({});

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await response.json();

      if (response.ok) {
        if (typeof window.gtag_report_conversion === 'function') {
          window.gtag_report_conversion();
        }
        setStatus({ loading: false, success: true, error: false, message: data.message });
        setForm(INITIAL_FORM);
        setTimeout(() => setStatus(prev => ({ ...prev, success: false, message: '' })), 5000);
      } else {
        if (data.errors) setErrors(data.errors);
        setStatus({ loading: false, success: false, error: true, message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch {
      setStatus({ loading: false, success: false, error: true, message: 'Network error. Please check your connection and try again.' });
    }
  };

  return (
    <section className="getstarted-section">
      <div className="getstarted-inner">
        <div className="getstarted-card">
          <div className="getstarted-left">
            <img src={contactWattle} alt="" className="getstarted-wattle" aria-hidden="true" />
            <h2 className="getstarted-title">Ready to Get Started?</h2>
            <p className="getstarted-desc">
              Speak with our team and get a solution tailored to your home.
            </p>
            <div className="getstarted-illustration">
              <img src={contactObj} alt="" />
            </div>
          </div>

          <div className="getstarted-form-panel">
            <form className="getstarted-form" onSubmit={handleSubmit}>

              <div className="form-group">
                <label className="form-label">Have you already installed solar panel?</label>
                <div className="radio-options">
                  <label className="radio-option">
                    <input type="radio" name="hasSolarPanel" value="yes"
                      checked={form.hasSolarPanel === 'yes'} onChange={handleChange}
                      disabled={status.loading} />
                    <span>Yes</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="hasSolarPanel" value="no"
                      checked={form.hasSolarPanel === 'no'} onChange={handleChange}
                      disabled={status.loading} />
                    <span>No</span>
                  </label>
                </div>
                {errors.hasSolarPanel && <span className="form-error">{errors.hasSolarPanel[0]}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">Name</label>
                <input type="text" name="name" value={form.name} onChange={handleChange}
                  placeholder="Full Name" className={`form-input${errors.name ? ' input-error' : ''}`}
                  disabled={status.loading} required />
                {errors.name && <span className="form-error">{errors.name[0]}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">Address</label>
                <input type="text" name="address" value={form.address} onChange={handleChange}
                  placeholder="Installation address" className={`form-input${errors.address ? ' input-error' : ''}`}
                  disabled={status.loading} />
                {errors.address && <span className="form-error">{errors.address[0]}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">Email</label>
                <input type="email" name="email" value={form.email} onChange={handleChange}
                  placeholder="your@email.com" className={`form-input${errors.email ? ' input-error' : ''}`}
                  disabled={status.loading} required />
                {errors.email && <span className="form-error">{errors.email[0]}</span>}
              </div>

              <div className="form-group">
                <label className="form-label">Phone</label>
                <input type="tel" name="phone" value={form.phone} onChange={handleChange}
                  placeholder="04XX XXX XXX" className={`form-input${errors.phone ? ' input-error' : ''}`}
                  disabled={status.loading} />
                {errors.phone && <span className="form-error">{errors.phone[0]}</span>}
              </div>

              {status.error && (
                <div className="form-alert form-alert-error">{status.message}</div>
              )}

              <button type="submit" className="getstarted-submit-btn" disabled={status.loading}>
                {status.loading ? 'Sending…' : (
                  <>
                    Get free quote
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12h14M12 5l7 7-7 7" stroke="#050b14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </>
                )}
              </button>

              {status.success && (
                <div className="form-alert form-alert-success">{status.message}</div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
